// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reports-filter {
  padding: 10px;
  border-radius: 4px;
  background: #FFFFFF;
}
.reports-filter .ant-select-single.ant-select-lg .ant-select-selector,
.reports-filter .ant-select-multiple.ant-select-lg,
.reports-filter .ant-picker-large .ant-picker-input > input {
  font-size: 14px;
}
.reports-filter .ant-picker {
  height: 40px;
}
.reports-filter__title {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-align: left;
  color: #181A1C;
}
.reports-filter__button {
  font-size: 14px;
  box-shadow: unset;
}
.reports-filter .ant-select-outlined.ant-select-multiple .ant-select-selection-item {
  padding-inline-start: 4px;
  padding-inline-end: 2px;
  border-radius: 4px;
  max-width: 136px;
  background: #E9EEF0;
}
.reports-filter .ant-select-multiple.ant-select-lg .ant-select-selection-item-content {
  font-weight: 400;
  font-size: 12px;
  line-height: 16.34px;
  letter-spacing: 0.15px;
  text-align: center;
  color: #181A1C;
  display: flex;
  align-items: center;
}
.reports-filter .ant-select-show-arrow.ant-select-open .ant-select-selector {
  border-bottom-left-radius: unset;
  border-bottom-right-radius: unset;
}

.reports-settings {
  justify-content: flex-start;
  border-radius: 6px;
  padding: 4px;
  background: #FFFFFF;
}
.reports-settings__button {
  height: 24px;
  border-radius: 4px;
  gap: 4px;
  padding-top: 2px;
  padding-right: 8px;
  padding-bottom: 4px;
  padding-left: 6px;
  background: #F3F6F8;
  cursor: pointer;
  flex-shrink: 0;
}
.reports-settings__button-text {
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #384146;
}
.reports-settings__channels {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.reports-settings__channel {
  border-radius: 4px;
  gap: 4px;
  padding-top: 2px;
  padding-right: 8px;
  padding-bottom: 4px;
  padding-left: 6px;
  background: #EFF5FF;
  height: 24px;
  max-width: 200px;
}
.reports-settings__channel-text {
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #083D76;
}
.reports-settings__channel-close {
  cursor: pointer;
}

.settings-popover {
  width: 320px;
  border-radius: 10px;
  gap: 6px;
}
.settings-popover__title {
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #092A3A;
}
.settings-popover__block {
  border-radius: 6px;
  gap: 8px;
  padding-top: 12px;
  padding-bottom: 12px;
  border: 1px solid #E3E9E5;
}
.settings-popover__items {
  height: 300px;
  overflow-y: auto;
}
.settings-popover__items::-webkit-scrollbar {
  width: 10px;
}
.settings-popover__items::-webkit-scrollbar-thumb {
  background: #181A1C;
  border-radius: 5px;
}
.settings-popover__items::-webkit-scrollbar-track {
  background-color: #ddd;
  border-radius: 4px;
}
.settings-popover__items::-webkit-scrollbar-button:hover {
  background-color: #999999;
}
.settings-popover__items-title {
  border-bottom: 1px solid #E3E9E5;
  padding: 0 8px 10px 8px;
  color: #000;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
}
.settings-popover__items-title-count {
  color: #7E8681;
}
.settings-popover__item {
  border-radius: 4px;
  gap: 8px;
  padding-top: 2px;
  padding-right: 8px;
  padding-bottom: 2px;
  padding-left: 8px;
}
.settings-popover .ant-radio-wrapper .ant-radio-checked .ant-radio-inner {
  border-color: #181A1C;
  background-color: #181A1C;
}
.settings-popover .ant-radio-wrapper .ant-radio-checked .ant-radio-inner:after {
  content: unset;
}
.settings-popover .ant-checkbox-checked .ant-checkbox-inner {
  border-color: #181A1C;
  background-color: #181A1C;
}
.settings-popover .ant-checkbox-indeterminate .ant-checkbox-inner {
  border-color: #181A1C;
  background-color: #181A1C;
}
.settings-popover .ant-checkbox-indeterminate .ant-checkbox-inner:after {
  background-color: #fff;
  height: 1px;
}
.settings-popover__select-all {
  padding: 0 8px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  text-align: center;
  color: #417EC6;
  cursor: pointer;
}

.ant-tooltip {
  max-width: 500px;
}

.ant-select-dropdown {
  border: 1px solid #d9d9d9;
  margin-top: -5px;
}
.ant-select-dropdown .ant-select-item-option-state {
  display: none;
}
.ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background-color: #fff;
}
.ant-select-dropdown .ant-select-item-option-content {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0;
  color: #000;
}
.ant-select-dropdown .ant-select-item {
  background-color: #fff;
}
.ant-select-dropdown .ant-select-item.ant-select-item-option {
  padding: 2px 3px;
  min-height: unset;
}
.ant-select-dropdown .ant-select-item .ant-checkbox-checked .ant-checkbox-inner {
  background: #000;
  border-color: #000;
}
.ant-select-dropdown .ant-checkbox .ant-checkbox-inner {
  border: 1.5px solid #7E8681;
}

.ant-select-dropdown.indicator-select .ant-select-item-option-selected:not(.ant-select-item-option-disabled) .ant-select-item-option-content {
  color: #1A76E2;
}

.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector {
  background: #E9EEF0;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/assets/reports.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;AACJ;AACI;;;EAGI,eAAA;AACR;AAEI;EACI,YAAA;AAAR;AAGI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AADR;AAII;EACI,eAAA;EACA,iBAAA;AAFR;AAKI;EACI,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHR;AAMI;EACI,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAJR;AAOI;EACI,gCAAA;EACA,iCAAA;AALR;;AASA;EACI,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AANJ;AAQI;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AANR;AAQQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AANZ;AAUI;EACI,aAAA;EACA,eAAA;EACA,QAAA;AARR;AAWI;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AATR;AAYI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAVR;AAaI;EACI,eAAA;AAXR;;AAeA;EACI,YAAA;EACA,mBAAA;EACA,QAAA;AAZJ;AAcI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAZR;AAeI;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;AAbR;AAgBI;EACI,aAAA;EACA,gBAAA;AAdR;AAgBQ;EACI,WAAA;AAdZ;AAiBQ;EACI,mBAAA;EACA,kBAAA;AAfZ;AAkBQ;EACI,sBAAA;EACA,kBAAA;AAhBZ;AAmBQ;EACI,yBAAA;AAjBZ;AAqBI;EACI,gCAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAnBR;AAsBI;EACI,cAAA;AApBR;AAuBI;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AArBR;AAwBI;EACI,qBAAA;EACA,yBAAA;AAtBR;AAwBQ;EACI,cAAA;AAtBZ;AA0BI;EACI,qBAAA;EACA,yBAAA;AAxBR;AA2BI;EACI,qBAAA;EACA,yBAAA;AAzBR;AA4BI;EACI,sBAAA;EACA,WAAA;AA1BR;AA6BI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AA3BR;;AA+BA;EACI,gBAAA;AA5BJ;;AA+BA;EACI,yBAAA;EACA,gBAAA;AA5BJ;AA8BI;EACI,aAAA;AA5BR;AA+BI;EACI,sBAAA;AA7BR;AAgCI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AA9BR;AAiCI;EACI,sBAAA;AA/BR;AAiCQ;EACI,gBAAA;EACA,iBAAA;AA/BZ;AAkCQ;EACI,gBAAA;EACA,kBAAA;AAhCZ;AAoCI;EACI,2BAAA;AAlCR;;AAwCQ;EACI,cAAA;AArCZ;;AA0CA;EACI,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAvCJ","sourcesContent":[".reports-filter {\n    padding: 10px;\n    border-radius: 4px;\n    background: #FFFFFF;\n\n    .ant-select-single.ant-select-lg .ant-select-selector,\n    .ant-select-multiple.ant-select-lg,\n    .ant-picker-large .ant-picker-input > input {\n        font-size: 14px;\n    }\n\n    .ant-picker {\n        height: 40px;\n    }\n\n    &__title {\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 16px;\n        text-align: left;\n        color: #181A1C;\n    }\n\n    &__button {\n        font-size: 14px;\n        box-shadow: unset;\n    }\n\n    .ant-select-outlined.ant-select-multiple .ant-select-selection-item {\n        padding-inline-start: 4px;\n        padding-inline-end: 2px;\n        border-radius: 4px;\n        max-width: 136px;\n        background: #E9EEF0;\n    }\n\n    .ant-select-multiple.ant-select-lg .ant-select-selection-item-content {\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 16.34px;\n        letter-spacing: 0.15px;\n        text-align: center;\n        color: #181A1C;\n        display: flex;\n        align-items: center;\n    }\n\n    .ant-select-show-arrow.ant-select-open .ant-select-selector {\n        border-bottom-left-radius: unset;\n        border-bottom-right-radius: unset;\n    }\n}\n\n.reports-settings {\n    justify-content: flex-start;\n    border-radius: 6px;\n    padding: 4px;\n    background: #FFFFFF;\n\n    &__button {\n        height: 24px;\n        border-radius: 4px;\n        gap: 4px;\n        padding-top: 2px;\n        padding-right: 8px;\n        padding-bottom: 4px;\n        padding-left: 6px;\n        background: #F3F6F8;\n        cursor: pointer;\n        flex-shrink: 0;\n\n        &-text {\n            font-weight: 600;\n            font-size: 12px;\n            line-height: 18px;\n            text-align: center;\n            color: #384146;\n        }\n    }\n\n    &__channels {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 4px;\n    }\n\n    &__channel {\n        border-radius: 4px;\n        gap: 4px;\n        padding-top: 2px;\n        padding-right: 8px;\n        padding-bottom: 4px;\n        padding-left: 6px;\n        background: #EFF5FF;\n        height: 24px;\n        max-width: 200px;\n    }\n\n    &__channel-text {\n        font-weight: 600;\n        font-size: 12px;\n        line-height: 18px;\n        color: #083D76;\n    }\n\n    &__channel-close {\n        cursor: pointer;\n    }\n}\n\n.settings-popover {\n    width: 320px;\n    border-radius: 10px;\n    gap: 6px;\n\n    &__title {\n        font-weight: 600;\n        font-size: 12px;\n        line-height: 18px;\n        color: #092A3A;\n    }\n\n    &__block {\n        border-radius: 6px;\n        gap: 8px;\n        padding-top: 12px;\n        padding-bottom: 12px;\n        border: 1px solid #E3E9E5;\n    }\n\n    &__items {\n        height: 300px;\n        overflow-y: auto;\n\n        &::-webkit-scrollbar {\n            width: 10px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n            background: #181A1C;\n            border-radius: 5px;\n        }\n\n        &::-webkit-scrollbar-track {\n            background-color: #ddd;\n            border-radius: 4px;\n        }\n\n        &::-webkit-scrollbar-button:hover {\n            background-color: #999999;\n        }\n    }\n\n    &__items-title {\n        border-bottom: 1px solid #E3E9E5;\n        padding: 0 8px 10px 8px;\n        color: #000;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 20px;\n        text-align: left;\n    }\n\n    &__items-title-count {\n        color: #7E8681;\n    }\n\n    &__item {\n        border-radius: 4px;\n        gap: 8px;\n        padding-top: 2px;\n        padding-right: 8px;\n        padding-bottom: 2px;\n        padding-left: 8px;\n    }\n\n    .ant-radio-wrapper .ant-radio-checked .ant-radio-inner {\n        border-color: #181A1C;\n        background-color: #181A1C;\n\n        &:after {\n            content: unset;\n        }\n    }\n\n    .ant-checkbox-checked .ant-checkbox-inner {\n        border-color: #181A1C;\n        background-color: #181A1C;\n    }\n\n    .ant-checkbox-indeterminate .ant-checkbox-inner {\n        border-color: #181A1C;\n        background-color: #181A1C;\n    }\n\n    .ant-checkbox-indeterminate .ant-checkbox-inner:after {\n        background-color: #fff;\n        height: 1px;\n    }\n\n    &__select-all {\n        padding: 0 8px;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 16px;\n        letter-spacing: 0;\n        text-align: center;\n        color: #417EC6;\n        cursor: pointer;\n    }\n}\n\n.ant-tooltip {\n    max-width: 500px;\n}\n\n.ant-select-dropdown {\n    border: 1px solid #d9d9d9;\n    margin-top: -5px;\n\n    .ant-select-item-option-state {\n        display: none;\n    }\n\n    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n        background-color: #fff;\n    }\n\n    .ant-select-item-option-content {\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 20px;\n        letter-spacing: 0;\n        color: #000;\n    }\n\n    .ant-select-item {\n        background-color: #fff;\n\n        &.ant-select-item-option {\n            padding: 2px 3px;\n            min-height: unset;\n        }\n\n        .ant-checkbox-checked .ant-checkbox-inner {\n            background: #000;\n            border-color: #000;\n        }\n    }\n\n    .ant-checkbox .ant-checkbox-inner {\n        border: 1.5px solid #7E8681;\n    }\n}\n\n.ant-select-dropdown.indicator-select {\n    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n        .ant-select-item-option-content {\n            color: #1A76E2;\n        }\n    }\n}\n\n.ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector {\n    background: #E9EEF0;\n    border: none;\n    border-radius: 4px;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 18px;\n    text-align: center;\n    vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
